import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query"
import {
  getArticulosByFilter,
  getArticulosContactByFilter,
} from "api/Articulo.service"
import { useCategoriaPadre } from "api/Categoria.hook"
import { GetArticulosByContactoQueryDtoProps } from "api/DTOs/GetArticulosByContactoQueryDto"
import { GetArticulosByFiltersQueryDtoProps } from "api/DTOs/GetArticulosByFiltersQueryDto"
import { ImpuestoEmpresaReadingDtoProps } from "api/DTOs/ImpuestoEmpresaReadingDto"
import { useImpuestoEmpresaNew } from "api/ImpuestoEmpresa.hook"
import { GetArticulosByContactoQueryDtoPropsIPagedEnumerableProps } from "api/Schemas/GetArticulosByContactoQueryDtoIPagedEnumerable"
import { GetArticulosByFiltersQueryDtoIPagedEnumerableProps } from "api/Schemas/GetArticulosByFiltersQueryDtoIPagedEnumerable"
import createImgURI from "common/utils/createImgURI"
import {
  formatCurrency,
  formatCurrencyWithDecimal,
} from "common/utils/currency"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useInView } from "react-intersection-observer"
import { FormikDocumentsProps } from "../../CreacionDocumento"
import {
  MODES_DOCUMENTOS,
  TYPES_DOCUMENTOS,
  getDocumentLabel,
} from "../../constant"
import CarritoArticulosDocumento from "./Components/CarritoArticulosDocumento/CarritoArticulosDocumento"
import { ArticulosSkeletons } from "./Components/SkeletonDocumento/SkeletonDocumento"
import ArticulosFilterDocumento from "./Components/articluosFilterDocumento/articluosFilterDocumento"

interface Categoria {
  id: string
  nombre: string
}
export interface ArticuloSelectedProps {
  cantidad: number
  categorias?: Categoria[]
  concepto: string
  cuentaContableId?: string | null
  id?: string
  impuestoArticuloPorcentaje?: number | undefined
  impuestoArticuloTipoId?: string | undefined
  impuestoNombre?: string | undefined
  index?: number
  tarifaImpuesto?: number
  numeroReferencia?: string
  precioVenta: number
  thumbnailBase64?: string
  thumbnailMediaType?: string
  tipoArticulo?: number
  total?: number
}
export interface FiltradoArticulosDto {
  PrecioVentaLowerLimit?: number
  PrecioVentaUpperLimit?: number
  CategoriasId?: string[]
  Concepto?: string
  SkipCount?: number
  MaxResultCount?: number
  EsDeCompra?: boolean
  LoadingMoreArticulos?: boolean
}

interface ArticuloItemProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: $TSMigrationFixMe
  addArticulo: (
    evento:
      | GetArticulosByFiltersQueryDtoProps
      | GetArticulosByContactoQueryDtoProps
  ) => void
  handleChangeCantidad: (evento: {
    articulo: string
    sum?: boolean
    cantidad?: string
  }) => void
  agregarCantidad: (evento: {
    articulo: string
    sum?: boolean
    cantidad?: string
  }) => void
  sinValorar: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: $TSMigrationFixMe
  girdShow: boolean
}

const ArticuloItem = ({
  values,
  addArticulo,
  handleChangeCantidad,
  agregarCantidad,
  sinValorar,
  item,
  girdShow,
}: ArticuloItemProps) => {
  const { t } = useTranslation()

  return girdShow ? (
    <div className='tw-w-full tw-shadow hover:tw-shadow-md tw-flex tw-flex-col tw-p-6 tw-bg-simple-10'>
      <div className='tw-w-full tw-h-48 tw-pb-3 tw-mb-2.5'>
        {item.thumbnailBase64 === null ? (
          <FontAwesomeIcon
            icon={["fal", "camera-slash"]}
            className='icon-size-lg'
          />
        ) : (
          <img
            src={createImgURI(item.thumbnailBase64, item.fichero?.mediaType)}
            alt='imagen'
            className='object-fit'
          />
        )}
      </div>
      <div className='tw-text-sm tw-text-neutral-75 tw-w-full tw-text-left'>
        {item.numeroReferencia}
      </div>
      <div className='tw-w-full tw-text-lg tw-text-left tw-font-medium tw-truncate'>
        {item.concepto}
      </div>
      <div className='tw-flex tw-flex-row tw-w-full tw-justify-between'>
        {item?.categorias?.[0]?.nombre && (
          <div className='tw-text-neutral-75 tw-w-fit tw-text-left'>
            {item?.categorias?.[0]?.nombre}
          </div>
        )}
        {!sinValorar && (
          <span className='tw-w-fit tw-text-xl tw-text-secondary tw-font-medium'>
            {formatCurrency(item.precioVenta, false, values?.divisa)}
          </span>
        )}
      </div>

      <div className='tw-mt-6'>
        {!values.conceptos.some(
          (element: ArticuloSelectedProps) => item.id === element.id
        ) ? (
          <div
            onClick={() => addArticulo(item)}
            className='hover:!tw-shadow-md hover:tw-border-1.5 hover:tw-font-medium tw-w-full tw-h-12 tw-rounded tw-border tw-border-primary tw-flex tw-justify-center tw-items-center tw-cursor-pointer'
          >
            <FontAwesomeIcon
              className='mr-2'
              icon={["fal", "cart-shopping"]}
            />{" "}
            {t("crear.documento.addArticleLabel")}
          </div>
        ) : (
          <div className='hover:!tw-shadow-md flex items-center justify-start'>
            <div
              onClick={() =>
                agregarCantidad({
                  articulo: item.id,
                  sum: false,
                })
              }
              className='flex items-center justify-center py-2 rounded-l shadow-sm w-1-4 border-1 border-gray pointer'
            >
              <FontAwesomeIcon
                className='icon-size-lg'
                icon={["fal", "minus"]}
              />
            </div>

            <input
              min={0}
              value={
                values.conceptos.find(
                  (element: ArticuloSelectedProps) => item.id === element.id
                ).cantidad
              }
              onChange={(e) =>
                handleChangeCantidad({
                  articulo: item.id,
                  cantidad: e.target.value,
                })
              }
              type='number'
              className='flex items-center justify-center py-2 text-center outarrows w-2-4 bg-bone border-gray border-1'
            />

            <div
              className='flex items-center justify-center py-2 rounded-r shadow-sm w-1-4 border-1 border-gray pointer'
              onClick={() =>
                agregarCantidad({
                  articulo: item.id,
                  sum: true,
                })
              }
            >
              <FontAwesomeIcon
                icon={["fal", "plus"]}
                className='icon-size-lg'
              />
            </div>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className='tw-w-full tw-shadow hover:tw-shadow-md tw-flex tw-flex-row tw-p-6 tw-items-center tw-bg-simple-10 tw-mb-5'>
      <div className='tw-w-60 tw-flex tw-flex-row tw-h-20 tw-items-center'>
        {item.thumbnailBase64 === null ? (
          <FontAwesomeIcon
            icon={["fal", "camera-slash"]}
            className='icon-size-lg'
          />
        ) : (
          <img
            src={createImgURI(item.thumbnailBase64, item.fichero?.mediaType)}
            alt='imagen'
            className='tw-w-20 tw-h-20'
          />
        )}
        <div className='tw-text-sm tw-w-40 md:tw-w-full tw-truncate tw-px-3 tw-text-neutral-75 tw-text-left'>
          {item.numeroReferencia}
        </div>
      </div>

      <div className='tw-flex tw-w-full tw-flex-col tw-items-center md:tw-flex-row'>
        <div className='tw-flex tw-w-full tw-flex-row'>
          <div className='tw-text-lg tw-text-left tw-w-48 md:tw-w-full tw-font-medium tw-truncate'>
            {item.concepto}
          </div>
          <div className='tw-flex tw-flex-row tw-justify-between '>
            {!values.config.sinValorar && (
              <span className='tw-text-xl md:tw-w-40 tw-text-right tw-mr-3 tw-text-secondary tw-font-medium'>
                {formatCurrency(item.precioVenta, false, values?.divisa)}
              </span>
            )}
          </div>
        </div>
        <div className='tw-w-64'>
          {!values.conceptos.some(
            (element: ArticuloSelectedProps) => item.id === element.id
          ) ? (
            <div
              onClick={() => addArticulo(item)}
              className='hover:!tw-shadow-md hover:tw-border-1.5 hover:tw-font-medium tw-w-full tw-h-12 tw-rounded tw-border tw-border-primary tw-flex tw-justify-center tw-items-center tw-cursor-pointer'
            >
              <FontAwesomeIcon
                className='mr-2'
                icon={["fal", "cart-shopping"]}
              />{" "}
              {t("crear.documento.addArticleLabel")}
            </div>
          ) : (
            <div className='hover:!tw-shadow-md flex items-center justify-start'>
              <div
                onClick={() =>
                  agregarCantidad({
                    articulo: item.id,
                    sum: false,
                  })
                }
                className='flex items-center justify-center py-2 rounded-l shadow-sm w-1-4 border-1 border-gray pointer'
              >
                <FontAwesomeIcon
                  className='icon-size-lg'
                  icon={["fal", "minus"]}
                />
              </div>

              <input
                min={0}
                value={
                  values.conceptos.find(
                    (element: ArticuloSelectedProps) => item.id === element.id
                  ).cantidad
                }
                onChange={(e) =>
                  handleChangeCantidad({
                    articulo: item.id,
                    cantidad: e.target.value,
                  })
                }
                type='number'
                className='flex items-center justify-center py-2 text-center outarrows w-2-4 bg-bone border-gray border-1'
              />

              <div
                className='flex items-center justify-center py-2 rounded-r shadow-sm w-1-4 border-1 border-gray pointer'
                onClick={() =>
                  agregarCantidad({
                    articulo: item.id,
                    sum: true,
                  })
                }
              >
                <FontAwesomeIcon
                  icon={["fal", "plus"]}
                  className='icon-size-lg'
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const SelectedArticlesDocument = ({
  values,
  setFieldValue,
  empresaActiva,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()
  const { ref, inView, entry } = useInView({
    threshold: 0.5,
  })
  const { categoriasPadre } = useCategoriaPadre()
  const [areItems, setAreItems] = useState<null | boolean>(false)
  const [queryParams, setQueryParams] = useState<
    undefined | FiltradoArticulosDto
  >(undefined)
  const { impuestoEmpresa } = useImpuestoEmpresaNew({
    EmpresaId: values?.empresaActiva?.id,
    TipoImpuestoEmpresa:
      values.documentoType.mode === MODES_DOCUMENTOS.VENTA ? 1 : 0,
    EsActivo: true,
    IsPagingEnabled: false,
  })

  const {
    data: articulosMisArticulos,
    isPending: isLoadingArticulosMisArticulos,
    fetchNextPage: fetchNextPageMisArticulos,
    hasNextPage: hasNextPageMisArticulos,
    isFetchingNextPage: isFetchingNextPageMisArticulos,
  } = useInfiniteQuery({
    queryKey: ["getArticulosByFilter", queryParams, empresaActiva?.id],
    enabled: Boolean(queryParams),
    queryFn: async ({ pageParam }: $TSMigrationFixMe) => {
      if (!queryParams) {
        throw new Error("Query params no están listos")
      }
      return (
        queryParams &&
        getArticulosByFilter({
          ...(queryParams ?? {}),
          SkipCount: pageParam,
        })
      )
    },
    getNextPageParam: (
      lastPage: GetArticulosByFiltersQueryDtoIPagedEnumerableProps
    ) => {
      return lastPage?.currentPage &&
        lastPage.currentPage * 10 < lastPage.totalCount
        ? lastPage?.currentPage * 10
        : undefined
    },
    initialPageParam: 0,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    retry: false,
  })

  const {
    data: articulosProveedor,
    isPending: isLoadingArticulosProveedor,
    fetchNextPage: fetchNextPageProveedor,
    hasNextPage: hasNextPageProveedor,
    isFetchingNextPage: isFetchingNextPageProveedor,
  } = useInfiniteQuery({
    queryKey: ["getArticulosByFilter", queryParams, values.librador.id],
    enabled:
      Boolean(queryParams) &&
      values.documentoType.mode === MODES_DOCUMENTOS.COMPRA,
    queryFn: async ({ pageParam }: $TSMigrationFixMe) => {
      if (!queryParams) {
        throw new Error("Query params no están listos")
      }
      return (
        queryParams &&
        getArticulosContactByFilter({
          queryParams: {
            ...(queryParams ?? {}),
            SkipCount: pageParam,
            EsDeCompra: false,
          },
          id: values.librador.id,
        })
      )
    },
    getNextPageParam: (
      lastPage: GetArticulosByContactoQueryDtoPropsIPagedEnumerableProps
    ) => {
      return lastPage?.currentPage &&
        lastPage.currentPage * 10 < lastPage.totalCount
        ? lastPage?.currentPage * 10
        : undefined
    },
    initialPageParam: 0,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    retry: false,
  })

  useEffect(() => {
    if (
      values.documentoType.type === TYPES_DOCUMENTOS.FACTURA ||
      values.documentoType.type === TYPES_DOCUMENTOS.PROFORMA
    ) {
      setFieldValue("librador", empresaActiva)
    }
  }, [empresaActiva, setFieldValue, values.documentoType.type])

  const articulosProveedorList =
    articulosProveedor?.pages?.flatMap((page) => page?.items) ?? []

  const articulosMisArticulosList =
    articulosMisArticulos?.pages?.flatMap((page) => page?.items) ?? []

  useEffect(() => {
    if (
      !isLoadingArticulosProveedor &&
      !isLoadingArticulosMisArticulos &&
      articulosMisArticulosList.length === 0 &&
      articulosProveedorList.length === 0 &&
      !areItems
    ) {
      setFieldValue("config.haveArticles", false)
      setFieldValue("documentoType.screen", 3)
      setAreItems(true)
    } else if (
      values.config.esCompraArticulos &&
      articulosProveedorList.length === 0 &&
      !isLoadingArticulosProveedor &&
      !areItems
    ) {
      setFieldValue("config.esCompraArticulos", false)
      setAreItems(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isLoadingArticulosProveedor,
    isLoadingArticulosMisArticulos,
    articulosMisArticulosList,
    articulosProveedorList,
  ])

  const recalculateTotal = useCallback(
    (updatedConceptos: ArticuloSelectedProps[]) => {
      const totalValue = updatedConceptos.reduce(
        (total: number, concepto: ArticuloSelectedProps) => {
          return total + concepto.cantidad * concepto.precioVenta
        },
        0
      )
      const cantidadValue = updatedConceptos.reduce(
        (total: number, concepto: ArticuloSelectedProps) => {
          return total + concepto.cantidad
        },
        0
      )

      setFieldValue("total", totalValue)
      setFieldValue("cantidadTotalArticulos", cantidadValue)
    },
    [setFieldValue]
  )

  const handleAddArticle = useCallback(
    (
      evento:
        | GetArticulosByFiltersQueryDtoProps
        | GetArticulosByContactoQueryDtoProps
    ) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const userTaxeSelected: ImpuestoEmpresaReadingDtoProps | any =
        impuestoEmpresa?.items?.find(
          ({ tipo, valor }) =>
            tipo ===
              (values.documentoType.mode === MODES_DOCUMENTOS.VENTA ? 1 : 0) &&
            valor === 21
        )

      const updatedConceptos = [
        ...values.conceptos,
        {
          ...evento,
          cantidad: 1,
          impuestoArticuloTipoId: userTaxeSelected?.id,
          impuestoArticuloPorcentaje: userTaxeSelected?.valor,
          impuestoNombre: userTaxeSelected?.nombre,
          total: evento.precioVenta,
          cuentaContableId: values.cuentaContableId ?? null,
          index: values.conceptos.length + 1,
        },
      ]

      setFieldValue("conceptos", updatedConceptos)
      recalculateTotal(updatedConceptos)
    },
    [
      impuestoEmpresa,
      values.conceptos,
      values.cuentaContableId,
      values.documentoType.mode,
      setFieldValue,
      recalculateTotal,
    ]
  )

  const handleDelete = useCallback(
    (id: string) => {
      const updatedConceptos = values.conceptos
        .filter((concepto: ArticuloSelectedProps) => concepto.id !== id)
        .filter((concepto: ArticuloSelectedProps) => concepto.cantidad > 0)

      setFieldValue("conceptos", updatedConceptos)
      recalculateTotal(updatedConceptos)
    },
    [recalculateTotal, setFieldValue, values.conceptos]
  )

  const handleCantidad = useCallback(
    (evento: { articulo: string; sum?: boolean; cantidad?: string }) => {
      const { articulo, sum, cantidad } = evento

      const updatedConceptos = values.conceptos
        .map((concepto: ArticuloSelectedProps) => {
          if (concepto.id === articulo) {
            let newCantidad
            if (typeof cantidad !== "undefined") {
              newCantidad = parseInt(cantidad, 10)
            } else if (sum) {
              newCantidad = concepto.cantidad + 1
            } else {
              newCantidad = concepto.cantidad - 1
            }
            return {
              ...concepto,
              cantidad: newCantidad,
              total: newCantidad * concepto.precioVenta,
            }
          }
          return concepto
        })
        .filter((concepto: ArticuloSelectedProps) => concepto.cantidad > 0)

      setFieldValue("conceptos", updatedConceptos)
      recalculateTotal(updatedConceptos)
    },
    [values.conceptos, setFieldValue, recalculateTotal]
  )

  useEffect(() => {
    if (values.config.esCompraArticulos) {
      if (
        inView &&
        hasNextPageProveedor &&
        entry?.isIntersecting &&
        articulosProveedorList.length
      ) {
        fetchNextPageProveedor()
      }
    } else if (
      inView &&
      hasNextPageMisArticulos &&
      entry?.isIntersecting &&
      articulosMisArticulosList.length
    ) {
      fetchNextPageMisArticulos()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView])

  return (
    <div>
      <div className='tw-h-[72px] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-px-6 tw-bg-simple-10'>
        <div className='tw-text-lg'>
          <span className='tw-font-medium'>
            {t("crear.documento.create")}{" "}
            {getDocumentLabel(values.documentoType.type, t)}
          </span>{" "}
          - {values.librador.razonSocial}
        </div>
        <div className='tw-flex tw-flex-row tw-w-fit tw-items-center'>
          <div className='tw-flex tw-flex-row tw-mr-4'>
            {t("crear.documento.totalPrice")}:{" "}
            <span className='tw-font-medium tw-ml-3'>
              {formatCurrencyWithDecimal(values.total, false, values?.divisa)}
            </span>
          </div>
          <div
            onClick={() =>
              setFieldValue(
                "modals.showModalCarrito",
                !values.modals.showModalCarrito
              )
            }
            className='tw-cursor-pointer tw-w-10 tw-h-10 tw-shadow hover:!tw-shadow-md tw-rounded tw-flex tw-justify-center tw-items-center tw-relative'
          >
            <FontAwesomeIcon
              icon={["fal", "cart-shopping"]}
              className='tw-w-6 tw-h-6 '
            />
            <div className='tw-absolute tw-top-1 tw-right-1 tw-w-3 tw-rounded-full tw-h-3 tw-flex tw-justify-center tw-items-center tw-bg-warning tw-text-white'>
              <span style={{ fontSize: 8 }}>
                {values.cantidadTotalArticulos}
              </span>
            </div>
          </div>
          <ButtonPrimeReact
            type='button'
            className='tw-h-10 tw-px-4 !tw-bg-secondary hover:!tw-bg-secondary-over hover:!tw-shadow-md tw-text-simple-10 tw-rounded !tw-border-none tw-ml-4'
            onClick={() => setFieldValue("documentoType.screen", 3)}
          >
            {t("crear.documento.generateLabel")}{" "}
            {getDocumentLabel(values.documentoType.type, t)}
          </ButtonPrimeReact>
        </div>
      </div>

      <div>
        <ArticulosFilterDocumento
          categorias={categoriasPadre ?? []}
          showDisplayModes
          values={values}
          setFieldValue={setFieldValue}
          onFilter={(event: FiltradoArticulosDto) => {
            setQueryParams(event)
          }}
        />
        <div
          className={`${
            values.config.gridArticles
              ? "tw-grid tw-w-full tw-gap-4 tw-px-4 tw-py-6 tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 2xl:tw-grid-cols-5"
              : "tw-flex tw-flex-col tw-gap-4 tw-px-4 tw-py-6"
          }`}
        >
          {(
            values.config.esCompraArticulos
              ? isLoadingArticulosProveedor
              : isLoadingArticulosMisArticulos
          ) ? (
            <ArticulosSkeletons isGrid={values.config.gridArticles} />
          ) : (
            (values.config.esCompraArticulos
              ? articulosProveedorList
              : articulosMisArticulosList
            )?.map(
              (
                item:
                  | GetArticulosByFiltersQueryDtoProps
                  | GetArticulosByContactoQueryDtoProps
                  | null
                  | undefined,
                index: number
              ) => (
                <ArticuloItem
                  key={`${index + 1}`}
                  values={values}
                  item={item}
                  sinValorar={values.config.sinValorar}
                  addArticulo={handleAddArticle}
                  handleChangeCantidad={handleCantidad}
                  agregarCantidad={handleCantidad}
                  girdShow={values.config.gridArticles}
                />
              )
            )
          )}
          {values.config.esCompraArticulos
            ? isFetchingNextPageProveedor
            : isFetchingNextPageMisArticulos && (
                <ArticulosSkeletons isGrid={values.config.gridArticles} />
              )}

          <div
            ref={ref}
            style={{ height: "20px", background: "transparent" }}
          />
        </div>
      </div>
      <CarritoArticulosDocumento
        values={values}
        setFieldValue={setFieldValue}
        handleChangeCantidad={handleCantidad}
        agregarCantidad={handleCantidad}
        handleDelete={handleDelete}
      />
    </div>
  )
}

export default SelectedArticlesDocument
